// extracted by mini-css-extract-plugin
export var colorSquare = "_qe-0";
export var danger = "_qe-5";
export var lightPink = "_qe-8";
export var neutralBlue = "_qe-7";
export var neutralYellow = "_qe-6";
export var normal = "_qe-1";
export var primary = "_qe-2";
export var primaryLight = "_qe-3";
export var solidBlack = "_qe-g";
export var solidGreen = "_qe-b";
export var solidLightBlue = "_qe-d";
export var solidNavy = "_qe-c";
export var solidOrange = "_qe-f";
export var solidPink = "_qe-e";
export var solidRed = "_qe-9";
export var solidYellow = "_qe-a";
export var success = "_qe-4";